export default class LoadQueue{
	loadQueue = [];

	add = (func) => {
		this.loadQueue.push(func);
	}

	start = () =>{
		this.handleLoadComplete();
	}

	handleLoadComplete = () => {
		let newFunc = this.loadQueue.shift();
		if(newFunc){
			let fd = newFunc();
			if(!fd){
				this.handleLoadComplete();
				return;
			}
			fd.promise.then(this.handleLoadComplete).catch(this.handleLoadComplete);
			this.onItemLoadStart(fd);
		}else{
			this.onComplete()
		}
	}

	onItemLoadStart = (loadItem) => {

	}

	onComplete = () => {

	}

}



// WEBPACK FOOTER //
// ./src/classes/LoadQueue.js